import { merge } from 'ramda';
import { TActions } from '../../../types/actions';
import { SAVE_DRAFT_START } from '../../../actions/draft';
import { PUBLISH_OFFER_START } from '../publishInfo';
import { CHANGE_MULTI_POSTING_ENABLED, UPDATE_OFFER, CHANGE_PREFERRED_COMMUNICATION_TYPE } from './actions';
import { EOfferStatus, IOfferState } from './types';

const initialState: Partial<IOfferState> = {
  id: null,
  category: null,
  dealType: null,
  photos: [],
  multiposting: {
    enabled: false,
  },
};

export function offer(state: IOfferState, action: TActions) {
  switch (action.type) {
    case UPDATE_OFFER:
      return merge(state, action.payload);

    case SAVE_DRAFT_START:
      return {
        ...state,
        status: EOfferStatus.draft,
      };

    case PUBLISH_OFFER_START:
      return {
        ...state,
        status: EOfferStatus.published,
      };

    case CHANGE_MULTI_POSTING_ENABLED:
      return {
        ...state,
        multiposting: {
          enabled: action.payload,
        },
      };

    case CHANGE_PREFERRED_COMMUNICATION_TYPE:
      return {
        ...state,
        communication: {
          preferredCommunicationType: action.payload,
        },
      };

    default:
      return state || initialState;
  }
}
